// Libs
import classNames from 'classnames/bind';
import { Grid2, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { EMPTY_VALUE } from '~/utils/constants/common';
import { IQuoteDetail } from '~/utils/interface/quotes';
import { formatPhoneNumber } from '~/utils/helper/common';
// Styles, images, icons
import styles from './ClientInfoQuoteDetail.module.scss';
import { icons } from '~/assets';

type Props = {
  detailQuote?: IQuoteDetail;
};

const cx = classNames.bind(styles);

const ClientInfoQuoteDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailQuote } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderValueItem = (label: string, value: string) => {
    return (
      <Stack gap={1}>
        <Typography className={cx('label')}>{label}</Typography>
        <Typography className={cx('value')}>{value}</Typography>
      </Stack>
    );
  };
  //#endregion Handle Function

  return (
    <Stack id='clientInfoQuoteDetailComponent' gap={6} className={cx('container')}>
      <BaseLabel styleType='title' label={t('quote_detail_title_client_information')} icon={icons.commonIconClient} />

      <Grid2 container rowSpacing={4} columnSpacing={2}>
        <Grid2 size={6}>
          <Typography className={cx('labelTitle')}>{t('quote_detail_title_personal_information')}</Typography>
        </Grid2>

        <Grid2 size={6}>
          <Typography className={cx('labelTitle')}>{t('quote_detail_title_contact_information')}</Typography>
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_first_name'), detailQuote?.client?.firstName || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_last_name'), detailQuote?.client?.lastName || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(
            t('quote_detail_title_primary_phone'),
            formatPhoneNumber(detailQuote?.client?.clientContacts?.[0]?.phoneNumber) || EMPTY_VALUE
          )}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(
            t('quote_detail_title_secondary_phone'),
            formatPhoneNumber(detailQuote?.client?.clientContacts?.[1]?.phoneNumber) || EMPTY_VALUE
          )}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_company'), detailQuote?.client?.companyName || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_title'), detailQuote?.client?.clientTitle || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(
            t('quote_detail_title_primary_email'),
            detailQuote?.client?.clientContacts?.[0]?.email || EMPTY_VALUE
          )}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(
            t('quote_detail_title_secondary_email'),
            detailQuote?.client?.clientContacts?.[1]?.email || EMPTY_VALUE
          )}
        </Grid2>

        <Grid2 size={12}>
          <Typography className={cx('labelTitle')}>{t('quote_detail_title_address_information')}</Typography>
        </Grid2>

        <Grid2 size={8}>
          {renderValueItem(t('quote_detail_title_street_address'), detailQuote?.clientAddress?.address || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={4}>
          {renderValueItem(t('quote_detail_title_suite_unit'), detailQuote?.clientAddress?.unitDetail || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={4}>
          {renderValueItem(t('quote_detail_title_city'), detailQuote?.clientAddress?.city || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={4}>
          {renderValueItem(t('quote_detail_title_state'), detailQuote?.clientAddress?.state || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={4}>
          {renderValueItem(t('quote_detail_title_zip_code'), detailQuote?.clientAddress?.postalCode || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={4}>
          {renderValueItem(t('quote_detail_title_country'), detailQuote?.clientAddress?.country || EMPTY_VALUE)}
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default ClientInfoQuoteDetail;
